import React, { useRef, useEffect, useState } from "react";
import {
    I2cCheckboxGroup,
    I2cListItem,
    I2cIcon,
    I2cCheckbox,
    I2cInput,
    I2cRadioButton,
    I2cRadioGroup,
    I2cTooltip,
    I2cSelect,
    I2cMenuItem,
    I2cDatePicker,
    I2cAlert,
    I2cFileUpload, I2cColorPicker
} from "@webcomponents/i2cwebcomponents/dist/react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from "react-query";
import * as Yup from "yup";
import FilesUploadService from "../../../Services/FilesUploadService";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { validationSchemaGeneralInfo } from "./ValidationSchema";
import {
    other_Languages, app_Selection_Programs, brand_Colors, website_Url, mobile_App_Publishing,
    languages_Selection
} from "./stringUtils";
import AppSelectionIcons from "../AppSelectionForProgram/AppSelectionIcons"
const GeneralInformation = ({
    type,
    setAddFormData,
    addFormData,
    setFormValidStates,
    formDataJson,
    isFetching,
}) => {

    const [colorPrimary, setColorPrimary] = useState('#ffffff');
    const [colorSecondary, setColorSecondary] = useState('#ffffff');
    const [colorNeutral, setColorNeutral] = useState('#ffffff');
    const additionalOpt = useRef(null);
    const checkboxRef = useRef(null);
    const Manual = useRef(null);
    const appSelectionForProgram = addFormData[1]?.["1_0"]?.app_selection_for_program || [];
    const handleNetworkCheckboxGroupChange = (event) => {
        let SelectedNetworkValue;
        SelectedNetworkValue = event;
        let updatedSelectedNetworks = [
            ...(methods.getValues("brand_info_general_info_card_network") ?? []),
        ];
        if (updatedSelectedNetworks.includes(SelectedNetworkValue)) {
            // If the card is already selected, remove it
            updatedSelectedNetworks = updatedSelectedNetworks.filter(
                (card) => card !== SelectedNetworkValue,
            );
        } else {
            // If the card is not selected, add it
            updatedSelectedNetworks.push(SelectedNetworkValue);
        }
        if (updatedSelectedNetworks.includes("Other") &&
            methods.watch("brand_info_general_info_card_network_other")?.length
        ) {
            methods.setValue("brand_info_general_info_card_network_other", "");
        }
        if (!updatedSelectedNetworks.includes("Other")) {
            methods.setValue("brand_info_general_info_card_network_other", "");
        }
        methods.setValue("brand_info_general_info_card_network", updatedSelectedNetworks);
        methods.trigger();
        handleValueChanges();
    };
    const handleMobileAppPublishing = (event) => {
        let selectedCardInfo;
        selectedCardInfo = event;
        let updatedSelectedCardsInfo = [
            ...methods.getValues("brand_info_general_info_responsible_for_app_publish"),
        ];

        if (updatedSelectedCardsInfo.includes(selectedCardInfo)) {
            // If the card is already selected, remove it
            updatedSelectedCardsInfo = updatedSelectedCardsInfo.filter(
                (card) => card !== selectedCardInfo,
            );
        } else {
            // If the card is not selected, add it
            updatedSelectedCardsInfo.push(selectedCardInfo);
        }
        methods.setValue("brand_info_general_info_responsible_for_app_publish", updatedSelectedCardsInfo);
        methods.trigger();
        handleValueChanges();
    };
    const handleLanguageSelection = (event) => {
        let selectedCardInfo;
        selectedCardInfo = event;
        let updatedSelectedCardsInfo = [
            ...methods.getValues("brand_info_general_info_language"),
        ];

        if (updatedSelectedCardsInfo.includes(selectedCardInfo)) {
            // If the card is already selected, remove it
            updatedSelectedCardsInfo = updatedSelectedCardsInfo.filter(
                (card) => card !== selectedCardInfo,
            );
        } else {
            // If the card is not selected, add it
            updatedSelectedCardsInfo.push(selectedCardInfo);
        }
        if (!updatedSelectedCardsInfo.includes(4)) {
            methods.setValue("brand_info_general_info_language_other", []);
        }
        methods.setValue("brand_info_general_info_language", updatedSelectedCardsInfo);
        methods.trigger();
        handleValueChanges();
    };
    // Initialize React Hook Form with Yup resolver
    const methods = useForm({
        resolver: yupResolver(validationSchemaGeneralInfo),
        mode: "all",
        reValidateMode: "all",
        shouldUseNativeValidation: false,
        criteriaMode: "all",
        defaultValues: {
            brand_info_general_info_client_name: "",
            brand_info_general_info_brand_name: "",
            brand_info_general_info_responsible_for_app_publish: [],
            brand_info_general_info_card_network: [],
            brand_info_general_info_card_network_other: "",
            brand_info_general_info_brand_color: "Brand color scheme",
            brand_info_general_info_brand_color_custom_primary: "",
            brand_info_general_info_brand_color_custom_secondary: "",
            brand_info_general_info_brand_color_custom_neutral: "",
            brand_info_general_info_url_type_enrollment_screen: "i2c standard URL",
            brand_info_general_info_url_type_enrollment_screen_custom: "",
            brand_info_general_info_language: [],
            brand_info_general_info_language_other: [],
            brand_info_general_info_target_launch_date: "",
            brand_info_general_info_target_launch_date_mobile_app: "",
            brand_info_general_info_target_launch_date_web_app: "",
            brand_info_general_info_brand_logo_file: ""
        },
    });
    const fields = [
        "brand_info_general_info_client_name",
        "brand_info_general_info_brand_name",
        "brand_info_general_info_card_network_other",
        "brand_info_general_info_brand_color",
        "brand_info_general_info_brand_color_custom_primary",
        "brand_info_general_info_brand_color_custom_secondary",
        "brand_info_general_info_brand_color_custom_neutral",
        "brand_info_general_info_url_type_enrollment_screen",
        "brand_info_general_info_url_type_enrollment_screen_custom",
        "brand_info_general_info_target_launch_date",
        "brand_info_general_info_target_launch_date_mobile_app",
        "brand_info_general_info_target_launch_date_web_app",
        "brand_info_general_info_brand_logo_file"
    ];

    const fieldsArray = [
        "brand_info_general_info_responsible_for_app_publish",
        "brand_info_general_info_card_network",
        "brand_info_general_info_language",
        "brand_info_general_info_language_other",
    ];
    useEffect(() => { 
        customElements.whenDefined('i2c-file-upload').then(() => {
          if (Manual.current !== null) {
            const myDropzone = Manual.current.getDropZone();
            const token = localStorage.getItem("token");
            myDropzone.options.url = process.env.REACT_APP_API_BASE_URL + "api/file/upload/pdf";
            myDropzone.options.headers = {
              'X-Requested-With': null,
              'Access-Control-Allow-Headers': null, 'Authorization': 'Bearer ' + token,
            };
          }
        });

    }, [])
    const formData = new FormData();
    const handleFileUpload = async (name) => {
        try {
            formData.append("file", Manual.current.fileUpload.files[0]);
            await fileUpload.mutate(formData);
        } catch (error) {
            console.log(error);
        } finally {
            methods.trigger();
        }
    };
    const fileUpload = useMutation({
        mutationFn: async (formData) => { 
            type === "credit" ?  setFormValidStates("2_0", false): setFormValidStates("3_0", false); 
            return await FilesUploadService.uploadFile(formData);
        },
        onSuccess: (data) => {
            methods.setValue("brand_info_general_info_brand_logo_file", data?.data?.url);
            methods.trigger();
            handleValueChanges();
        },
        onError: (e) => {
            console.log("api error");
        },
    });
    useEffect(() => {
        if (!isFetching && Object.keys(formDataJson ?? {}).length) {
            if (type === "credit") {
                fields.forEach((field) => {
                    methods.setValue(field, formDataJson[2]["2_0"][field] ?? "");
                });
                fieldsArray.forEach((field) => {
                    methods.setValue(field, formDataJson[2]["2_0"][field] ?? []);
                });
            }
            else {
                fields.forEach((field) => {
                    methods.setValue(field, formDataJson[3]["3_0"][field] ?? "");
                });
                fieldsArray.forEach((field) => {
                    methods.setValue(field, formDataJson[3]["3_0"][field] ?? []);
                });
            }
            methods.trigger();
            handleValueChanges();
        }
    }, [isFetching]);
    // Controlls destructuring from the method
    const {
        control,
        formState: { errors },
    } = methods;

    // Trigger validation when component mounts
    React.useEffect(() => {
        methods.trigger();
    }, []);

    const handleValueChanges = () => {
        const values = methods.getValues();
        if (type === "credit") {
            setAddFormData({
                ...addFormData,
                2: {
                    ...addFormData["2"],
                    "2_0": { ...values },
                },
            });
        }
        else {
            setAddFormData({
                ...addFormData,
                3: {
                    ...addFormData["3"],
                    "3_0": { ...values },
                },
            });
        }
    };
    console.log("api error" ,errors);
    // Update form validation state when errors change
    React.useEffect(() => {
        const errorsLength = Object.keys(errors)?.length;
        if (type === "credit") {
            if (errorsLength === 0) setFormValidStates("2_0", true);
            else setFormValidStates("2_0", false);
        }
        else {
            if (errorsLength === 0) setFormValidStates("3_0", true);
            else setFormValidStates("3_0", false);
        }

    }, [Object.keys(errors)?.length]);


    return (
        <React.Fragment>
            <div className="forms-instance">
                <div i2c-grid="grid gap-md" className="section-space">
                    <div i2c-grid="12">
                        <div className="label">
                            Please indicate if you want to select i2c C-HolderWeb, C-Holder Mobile, or both for your program.
                        </div>
                    </div>
                    <div i2c-grid="12">
                        <div i2c-grid="grid gap-sm 12 6@md">
                            <div className="single-field-wrapper">
                                <Controller
                                    name="brand_info_general_info_client_name"
                                    control={control}
                                    render={({ field }) => (
                                        <I2cInput
                                            {...field}
                                            className="single-input-field"
                                            placeholder="Client Name"
                                            onI2cInput={(e) => {
                                                const value = e.target.value;
                                                field.onChange(value);
                                                handleValueChanges();
                                            }}
                                            label="Client Name"
                                            name={"brand_info_general_info_client_name"}
                                            size="large"
                                        />
                                    )}
                                />
                            </div>
                            <div className="single-field-wrapper">
                                <Controller
                                    name="brand_info_general_info_brand_name"
                                    control={control}
                                    render={({ field }) => (
                                        <I2cInput
                                            {...field}
                                            className="single-input-field"
                                            placeholder="Brand Name"
                                            onI2cInput={(e) => {
                                                const value = e.target.value;
                                                field.onChange(value);
                                                handleValueChanges();
                                            }}
                                            label="Brand Name"
                                            name={"brand_info_general_info_brand_name"}
                                            size="large"
                                        />
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section-space">
                    <div className="sub-heading mb-24">
                        <span className="productIconFlex">
                            <span>Mobile App Publishing</span>
                            <AppSelectionIcons
                                appSelectionForProgram={appSelectionForProgram}
                                mobileLink="https://example.com/mobile-app-a"
                                webLink="https://example.com/web-app-a"
                            />
                        </span>
                    </div>
                    <div className="custom-label-light mb-8">
                        Please specify who would be responsible for Mobile App publishing on the App Store and Play Store.
                    </div>
                    <I2cCheckboxGroup name="brand_info_general_info_responsible_for_app_publish" ref={checkboxRef}>
                        <div i2c-grid="grid gap-sm">
                            {mobile_App_Publishing.map((card, index) => (
                                <div key={index} i2c-grid="4@md">
                                    <I2cListItem
                                        variant="receipt"
                                        label={card.label}
                                        sublabel=""
                                        value=""
                                        type="checkbox"
                                        checked={methods
                                            .watch("brand_info_general_info_responsible_for_app_publish")
                                            .includes(card.value)}
                                        onI2cCheckboxClicked={(e) =>
                                            handleMobileAppPublishing(card.value)
                                        }
                                    >
                                        <I2cCheckbox
                                            slot="prefix"
                                            value={card.value}
                                            label=""
                                            ignoreTab
                                            filled
                                            checked={methods
                                                .watch("brand_info_general_info_responsible_for_app_publish")
                                                .includes(card.value)}
                                            className="customCheckbox"
                                        ></I2cCheckbox>
                                    </I2cListItem>
                                </div>
                            ))}
                        </div>
                    </I2cCheckboxGroup>
                </div>
                <div i2c-grid="grid gap-md" className="section-space">
                    <div i2c-grid="12">
                        <div className="sub-heading mb-24">
                            <span className="productIconFlex">
                                <span>Card Network</span>
                                <AppSelectionIcons
                                    appSelectionForProgram={appSelectionForProgram}
                                    mobileLink="https://example.com/mobile-app-a"
                                    webLink="https://example.com/web-app-a"
                                />
                            </span>
                        </div>
                        <div className="single-field-wrapper">
                            <Controller
                                name="brand_info_general_info_card_network"
                                control={control}
                                render={({ field }) => (
                                    <>
                                        <I2cCheckboxGroup
                                            {...field}
                                            className="centeredCheckbox checkbox-margin"
                                            label="Please specify the card network."
                                        >
                                            <div i2c-grid="grid gap-sm">
                                                {app_Selection_Programs.map((card, index) => (
                                                    <I2cListItem
                                                        key={index}
                                                        i2c-grid="4@md"
                                                        variant="receipt"
                                                        label={card.label}
                                                        sublabel=""
                                                        value=""
                                                        type="checkbox"
                                                        checked={methods
                                                            .watch("brand_info_general_info_card_network")
                                                            .includes(card.value)}
                                                        onI2cCheckboxClicked={(e) => {
                                                            handleNetworkCheckboxGroupChange(card.value);
                                                        }}
                                                    >
                                                        <I2cIcon
                                                            slot="prefix"
                                                            src={card.icon}
                                                            label="icon"
                                                        ></I2cIcon>
                                                        <I2cCheckbox
                                                            slot="checkbox"
                                                            name="brand_info_general_info_card_network"
                                                            filled
                                                            value={card.value}
                                                            label=""
                                                            ignoreTab
                                                            checked={methods
                                                                .watch("brand_info_general_info_card_network")
                                                                .includes(card.value)}
                                                            className="customCheckbox"
                                                        ></I2cCheckbox>
                                                    </I2cListItem>
                                                ))}
                                            </div>
                                        </I2cCheckboxGroup>
                                        <ErrorMessage
                                            show={
                                                errors.brand_info_general_info_card_network &&
                                                    methods.formState.touchedFields.brand_info_general_info_card_network
                                                    ? true
                                                    : false
                                            }
                                            message={
                                                errors.brand_info_general_info_card_network?.message ?? "Invalid input"
                                            }
                                        />
                                    </>
                                )}
                            />
                        </div>
                    </div>
                    {
                        methods.watch('brand_info_general_info_card_network').includes('Other') &&
                        <div i2c-grid="12 6@md" className="single-field-wrapper">
                            <Controller
                                name="brand_info_general_info_card_network_other"
                                control={control}
                                render={({ field }) => (
                                    <I2cInput
                                        {...field}
                                        className="single-input-field"
                                        placeholder="Enter network details"
                                        required
                                        onI2cInput={(e) => {
                                            const value = e.target.value;
                                            field.onChange(value);
                                            handleValueChanges();
                                        }}
                                        size="large"
                                        name={"brand_info_general_info_card_network_other"}
                                    >
                                        <span slot="label" className="organize-tooltip">
                                            <span className="custom-label">
                                                {" "}
                                                Enter card network.
                                            </span>
                                        </span>
                                    </I2cInput>
                                )}
                            />
                        </div>
                    }
                </div>
                <div i2c-grid="grid gap-md" className="section-space">
                    <div i2c-grid="12">
                        <div className="sub-heading">
                            <span className="productIconFlex">
                                <span slot="label" className="organize-tooltip">
                                    Brand Colors
                                    <I2cTooltip
                                        content={`Brand colors will be used to maintain visual and graphical consistency throughout the application. You can either allow i2c to choose the colors consistent with the brand logo or list the colors that that you want to use.`}
                                        placement="right-start"
                                    >
                                        <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
                                    </I2cTooltip>
                                </span>
                                <AppSelectionIcons
                                    appSelectionForProgram={appSelectionForProgram}
                                    mobileLink="https://example.com/mobile-app-a"
                                    webLink="https://example.com/web-app-a"
                                />
                            </span>
                        </div>
                    </div>
                    <div i2c-grid="12">
                        <div className="single-field-wrapper">
                            <Controller
                                name="brand_info_general_info_brand_color"
                                control={control}
                                render={({ field }) => (
                                    <I2cRadioGroup
                                        label="Please specify the brand colors you want to use."
                                        {...field}
                                        name="brand_info_general_info_brand_color"
                                        onI2cChange={(e) => {
                                            field.onChange(e);
                                            if(e.target.value === "Custom color scheme"){
                                                methods.setValue("brand_info_general_info_brand_logo_file","")
                                            }else{
                                                methods.setValue("brand_info_general_info_brand_color_custom_primary","")
                                                methods.setValue("brand_info_general_info_brand_color_custom_secondary","")
                                                methods.setValue("brand_info_general_info_brand_color_custom_neutral","")
                                            }
                                            methods.trigger();
                                            handleValueChanges();
                                        }}
                                    >
                                        {brand_Colors.map((bc, index) => (
                                            <I2cRadioButton
                                                key={index}
                                                checked={
                                                    methods.watch("brand_info_general_info_brand_color") === bc
                                                }
                                                value={bc}
                                            >
                                                {bc}
                                            </I2cRadioButton>
                                        ))}
                                    </I2cRadioGroup>
                                )}
                            />
                            <ErrorMessage
                                show={
                                    errors.brand_info_general_info_brand_color &&
                                        methods.formState.touchedFields.brand_info_general_info_brand_color
                                        ? true
                                        : false
                                }
                                message={errors.brand_info_general_info_brand_color?.message ?? "Invalid input"}
                            />
                        </div>
                    </div>
                    {methods.watch("brand_info_general_info_brand_color") === "Custom color scheme" ? (
                        <div i2c-grid="12">
                            <div className="single-field-wrapper mb-24 halfWidth">
                                <Controller
                                    name="brand_info_general_info_brand_color_custom_primary"
                                    control={control}
                                    render={({ field }) => (
                                        <I2cColorPicker layout="custom"   label="Primary"
                                            {...field}
                                            className="single-input-field"
                                            required
                                            onI2cChange={(e) => {
                                                const value = e.target.value || e.target.getFormattedValue();
                                                field.onChange(value);
                                                setColorPrimary(value);
                                                handleValueChanges();
                                            }}
                                            placement="top"
                                            size="large"
                                            name={"brand_info_general_info_brand_color_custom_primary"}
                                        >
                                            <I2cInput
                                                readonly label="Primary" value={colorPrimary} slot="trigger" style={{ '--custom-preview': colorPrimary }}>
                                                <I2cIcon style={{ '--featured-color': colorPrimary }} slot="prefix" name="cs-bold-indicator"></I2cIcon>
                                            </I2cInput>
                                        </I2cColorPicker>
                                    )}
                                />
                            </div>
                            <div className="single-field-wrapper mb-24 halfWidth">
                                <Controller
                                    name="brand_info_general_info_brand_color_custom_secondary"
                                    control={control}
                                    render={({ field }) => (
                                        <I2cColorPicker layout="custom" label="Primary"
                                            {...field}
                                            className="single-input-field"
                                            required
                                            onI2cChange={(e) => {
                                                const value = e.target.value || e.target.getFormattedValue();
                                                field.onChange(value);
                                                setColorSecondary(value);
                                                handleValueChanges();
                                            }}
                                            placement="top"
                                            size="large"
                                            name={"brand_info_general_info_brand_color_custom_secondary"}
                                        >
                                            <I2cInput
                                                readonly label="Secondary" value={colorSecondary} name={"brand_info_general_info_brand_color_custom_secondary"} slot="trigger" style={{ '--custom-preview': colorSecondary }}>
                                                <I2cIcon style={{ '--featured-color': colorSecondary }} slot="prefix" name="cs-bold-indicator"></I2cIcon>
                                            </I2cInput>
                                        </I2cColorPicker>

                                    )}
                                />
                            </div>
                            <div className="single-field-wrapper halfWidth">
                                <Controller
                                    name="brand_info_general_info_brand_color_custom_neutral"
                                    control={control}
                                    render={({ field }) => (
                                        <I2cColorPicker layout="custom" label="Primary"
                                            {...field}
                                            className="single-input-field"
                                            required
                                            onI2cChange={(e) => {
                                                const value = e.target.value || e.target.getFormattedValue();
                                                field.onChange(value);
                                                setColorNeutral(value);
                                                handleValueChanges();
                                            }}
                                            placement="top"
                                            size="large"
                                            name={"brand_info_general_info_brand_color_custom_neutral"}
                                        >
                                            <I2cInput
                                                readonly label="Neutral" value={colorNeutral} name={"brand_info_general_info_brand_color_custom_neutral"} slot="trigger" style={{ '--custom-preview': colorNeutral }}>
                                                <I2cIcon style={{ '--featured-color': colorNeutral }} slot="prefix" name="cs-bold-indicator"></I2cIcon>
                                            </I2cInput>
                                        </I2cColorPicker>
                                    )}
                                />
                            </div>
                        </div>
                    )
                        :
                        (
                            <div i2c-grid="12 12@md">
                                <div className="custom-label-light mb-1-5">
                                    Upload logo source file
                                </div>
                                <Controller
                                    name="brand_info_general_info_brand_logo_file"
                                    control={control}
                                    render={({ field }) => (
                                        <I2cFileUpload
                                        ref={Manual}
                                        autoProcessQueue={false}
                                        no-mobile-controls
                                        max-files={1}
                                        className="customFileUpload"
                                        setAcceptedFiles=".svg, .ai, .pdf, .eps"
                                        icon="linear-document-upload"
                                        label="Click to upload"
                                        caption="or drag and drop"
                                        name="brand_info_general_info_brand_logo_file"
                                        message="Format must be SVG, AI, PDF or EPS Format."
                                        onI2cFileRemoved={(e) => {
                                        //   if (
                                        //     formDataJson[0]["0_0"]?.brand_info_general_info_brand_logo_file?.length
                                        //   )
                                        //     methods.setValue(
                                        //       "brand_info_general_info_brand_logo_file",
                                        //       formDataJson[0]["0_0"]?.brand_info_general_info_brand_logo_file,
                                        //     );
                                        //   else methods.setValue("brand_info_general_info_brand_logo_file", "");
                                          methods.setValue("brand_info_general_info_brand_logo_file", "");
                                          methods.trigger();
                                          handleValueChanges();
                                        }}
                                        onI2cAddedFile={(e) => {
                                          handleFileUpload(
                                            Manual.current.getDropZone().files[
                                              Manual.current.getDropZone().files.length - 1
                                            ],
                                          );
                                        }}
                                      />
                                    )}
                                />
                            </div>
                        )
                    }
                </div>
                <div i2c-grid="grid gap-md" className="section-space">
                    <div i2c-grid="12">
                        <div className="sub-heading mb-24">
                            <span className="productIconFlex">
                                Website URL
                                <I2cTooltip
                                    content={`i2c’s standard nomenclature is: https://brandname-ch.mycardplace.com/cholder/ Note: An SSL certificate is required if you choose to use your own registered domain.`}
                                    placement="right-start"
                                >
                                    <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
                                </I2cTooltip>
                                <AppSelectionIcons
                                    appSelectionForProgram={appSelectionForProgram}
                                    mobileLink="https://example.com/mobile-app-a"
                                    webLink="https://example.com/web-app-a"
                                />
                            </span>
                        </div>
                        <div className="single-field-wrapper">
                            <Controller
                                name="brand_info_general_info_url_type_enrollment_screen"
                                control={control}
                                render={({ field }) => (
                                    <I2cRadioGroup
                                        label="Please select the type of URL you want to use for enrollment screens."
                                        {...field}
                                        name="brand_info_general_info_url_type_enrollment_screen"
                                        onI2cChange={(e) => {
                                            field.onChange(e);
                                            if(e.target.value !== "Use custom URL"){
                                                methods.setValue("brand_info_general_info_url_type_enrollment_screen_custom","")
                                            }
                                            methods.trigger();
                                            handleValueChanges();
                                        }}
                                    >
                                        {website_Url.map((wu, index) => (
                                            <I2cRadioButton
                                                key={index}
                                                checked={
                                                    methods.watch("brand_info_general_info_url_type_enrollment_screen") === wu
                                                }
                                                value={wu}
                                            >
                                                {wu}
                                            </I2cRadioButton>
                                        ))}
                                    </I2cRadioGroup>
                                )}
                            />
                            <ErrorMessage
                                show={
                                    errors.brand_info_general_info_url_type_enrollment_screen &&
                                        methods.formState.touchedFields.brand_info_general_info_url_type_enrollment_screen
                                        ? true
                                        : false
                                }
                                message={errors.brand_info_general_info_url_type_enrollment_screen?.message ?? "Invalid input"}
                            />
                        </div>
                    </div>
                    {methods.watch("brand_info_general_info_url_type_enrollment_screen") === "Use custom URL" && (
                        <>
                            <div i2c-grid="7@md" className="single-field-wrapper">
                                <Controller
                                    name="brand_info_general_info_url_type_enrollment_screen_custom"
                                    control={control}
                                    render={({ field }) => (
                                        <I2cInput
                                            {...field}
                                            className="single-input-field"
                                            placeholder="www.i2cinc.com/enrollment"
                                            required
                                            onI2cInput={(e) => {
                                                const value = e.target.value;
                                                field.onChange(value);
                                                handleValueChanges();
                                            }}
                                            size="large"
                                            name={"brand_info_general_info_url_type_enrollment_screen_custom"}
                                            prefix_label="http://"
                                        >
                                            <span slot="label" className="organize-tooltip">
                                                <span className="custom-label">
                                                    {" "}
                                                    Custom URL
                                                </span>
                                            </span>
                                        </I2cInput>
                                    )}
                                />
                            </div>
                        </>
                    )}
                </div>
                <div i2c-grid="grid gap-md" className="section-space">
                    <div i2c-grid="12">
                        <div className="sub-heading mb-24">
                            <span className="productIconFlex">
                                Language Selection
                                <I2cTooltip
                                    content={`The cardholder website can be offered in multiple languages.
                                        If you are supporting a new language (indicated by the “Other” option here, 
                                        i2c will require the custom text in all selected or specified languages.
                                        The “Other” option may also require additional development work to support client specific modules.`}
                                    placement="right-start"
                                >
                                    <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
                                </I2cTooltip>
                                <AppSelectionIcons
                                    appSelectionForProgram={appSelectionForProgram}
                                    mobileLink="https://example.com/mobile-app-a"
                                    webLink="https://example.com/web-app-a"
                                />
                            </span>
                        </div>
                        <I2cCheckboxGroup name="brand_info_general_info_language" ref={checkboxRef} label="Select the languages that apply.">
                            <div i2c-grid="grid gap-sm">
                                {languages_Selection.map((card, index) => (
                                    <div key={index} i2c-grid="4@md">
                                        <I2cListItem
                                            variant="receipt"
                                            label={card.label}
                                            sublabel=""
                                            value=""
                                            type="checkbox"
                                            checked={methods
                                                .watch("brand_info_general_info_language")
                                                .includes(card.value)}
                                            onI2cCheckboxClicked={(e) =>
                                                handleLanguageSelection(card.value)
                                            }
                                        >
                                            <I2cCheckbox
                                                slot="prefix"
                                                value={card.value}
                                                label=""
                                                ignoreTab
                                                filled
                                                checked={methods
                                                    .watch("brand_info_general_info_language")
                                                    .includes(card.value)}
                                                className="customCheckbox"
                                            ></I2cCheckbox>
                                        </I2cListItem>
                                    </div>
                                ))}
                            </div>
                        </I2cCheckboxGroup>
                    </div>
                    {
                        methods.watch('brand_info_general_info_language').includes('Other') &&
                        <div i2c-grid="6@md">
                            <div className="single-field-wrapper">
                                <Controller
                                    name="brand_info_general_info_language_other"
                                    control={control}
                                    render={({ field }) => (
                                        <I2cSelect
                                            {...field}
                                            clearable
                                            multiple
                                            label="Other Languages"
                                            onI2cChange={(e) => {
                                                // methods.setValue("brand_info_general_info_language_other", e.target.value);
                                                field.onChange(e);
                                                methods.trigger();
                                                handleValueChanges();
                                            }}
                                            value={methods.watch("brand_info_general_info_language_other")}
                                            placeholder="Select Other Language"
                                            // required
                                            name="brand_info_general_info_language_other"
                                            size="large"
                                        >
                                            {other_Languages.map((otherLanguage, index) => (
                                                <I2cMenuItem key={index} value={otherLanguage}>
                                                    {otherLanguage}
                                                </I2cMenuItem>
                                            ))}
                                        </I2cSelect>
                                    )}
                                />
                                <ErrorMessage
                                    show={
                                        errors.brand_info_general_info_language_other &&
                                            methods.formState.touchedFields.brand_info_general_info_language_other
                                            ? true
                                            : false
                                    }
                                    message={errors.brand_info_general_info_language_other?.message ?? "Invalid input"}
                                />
                            </div>
                        </div>
                    }
                </div>
                <div i2c-grid="grid gap-md" className="section-space">
                    <div i2c-grid="12">
                        <div className="sub-heading">
                            <span className="productIconFlex">
                                <span>
                                    Target Launch Date
                                </span>
                                <AppSelectionIcons
                                    appSelectionForProgram={appSelectionForProgram}
                                    mobileLink="https://example.com/mobile-app-a"
                                    webLink="https://example.com/web-app-a"
                                />
                            </span>
                        </div>
                    </div>
                    <div i2c-grid="6@md">
                        <div className="single-field-wrapper">
                            <Controller
                                name="brand_info_general_info_target_launch_date"
                                control={control}
                                render={({ field }) => (
                                    <I2cDatePicker
                                        {...field}
                                        I2cDatePicker
                                        hoist
                                        dateFormat="d-m-Y"
                                        onI2cDateApply={(e) => {
                                            if (e.target?.appliedDate) {
                                                const kickOffDate =
                                                    e.target?.appliedDate[0]?.toDateString() ?? "";
                                                const goLiveDate = new Date(
                                                    methods.watch("pd_go_live"),
                                                );
                                                if (goLiveDate < new Date(kickOffDate)) {
                                                    methods.setError("brand_info_general_info_target_launch_date", {
                                                        message:
                                                            "Kick off date should be less than the go live date",
                                                    });
                                                }
                                                field.onChange(kickOffDate);
                                            } else field.onChange("");
                                            handleValueChanges();
                                            methods.trigger();
                                        }}
                                        placeholder="Select dates"
                                        minDate={new Date().setHours(0, 0, 0, 0)}
                                        size="large"
                                        required
                                        name="brand_info_general_info_target_launch_date"
                                        label="Select target launch date"
                                        defaultDate={
                                            methods.watch("brand_info_general_info_target_launch_date")
                                                ? new Date(methods.watch("brand_info_general_info_target_launch_date"))
                                                : ""
                                        }
                                    />
                                )}
                            />
                            <ErrorMessage
                                show={
                                    errors.brand_info_general_info_target_launch_date &&
                                        methods.formState.touchedFields.brand_info_general_info_target_launch_date
                                        ? true
                                        : false
                                }
                                message={errors.brand_info_general_info_target_launch_date?.message ?? "Invalid input"}
                            />
                        </div>
                    </div>
                    <div i2c-grid="6@md">
                        <div className="single-field-wrapper">
                            <Controller
                                name="brand_info_general_info_target_launch_date_mobile_app"
                                control={control}
                                render={({ field }) => (
                                    <I2cDatePicker
                                        {...field}
                                        I2cDatePicker
                                        hoist
                                        dateFormat="d-m-Y"
                                        onI2cDateApply={(e) => {
                                            if (e.target?.appliedDate) {
                                                const kickOffDate =
                                                    e.target?.appliedDate[0]?.toDateString() ?? "";
                                                const goLiveDate = new Date(
                                                    methods.watch("brand_info_general_info_target_launch_date_mobile_app"),
                                                );
                                                if (goLiveDate < new Date(kickOffDate)) {
                                                    methods.setError("brand_info_general_info_target_launch_date_mobile_app", {
                                                        message:
                                                            "Kick off date should be less than the go live date",
                                                    });
                                                }
                                                field.onChange(kickOffDate);
                                            } else field.onChange("");
                                            handleValueChanges();
                                            methods.trigger();
                                        }}
                                        placeholder="Select dates"
                                        minDate={new Date().setHours(0, 0, 0, 0)}
                                        size="large"
                                        name="brand_info_general_info_target_launch_date_mobile_app"
                                        label="Target Launch Date (Mobile App)"
                                        defaultDate={
                                            methods.watch("brand_info_general_info_target_launch_date_mobile_app")
                                                ? new Date(methods.watch("brand_info_general_info_target_launch_date_mobile_app"))
                                                : ""
                                        }
                                    />
                                )}
                            />
                            <ErrorMessage
                                show={
                                    errors.brand_info_general_info_target_launch_date_mobile_app &&
                                        methods.formState.touchedFields.brand_info_general_info_target_launch_date_mobile_app
                                        ? true
                                        : false
                                }
                                message={errors.brand_info_general_info_target_launch_date_mobile_app?.message ?? "Invalid input"}
                            />
                        </div>
                    </div>
                    <div i2c-grid="6@md">
                        <div className="single-field-wrapper">
                            <Controller
                                name="brand_info_general_info_target_launch_date_web_app"
                                control={control}
                                render={({ field }) => (
                                    <I2cDatePicker
                                        {...field}
                                        I2cDatePicker
                                        hoist
                                        dateFormat="d-m-Y"
                                        onI2cDateApply={(e) => {
                                            if (e.target?.appliedDate) {
                                                const kickOffDate =
                                                    e.target?.appliedDate[0]?.toDateString() ?? "";
                                                const goLiveDate = new Date(
                                                    methods.watch("brand_info_general_info_target_launch_date_web_app"),
                                                );
                                                if (goLiveDate < new Date(kickOffDate)) {
                                                    methods.setError("brand_info_general_info_target_launch_date_web_app", {
                                                        message:
                                                            "Kick off date should be less than the go live date",
                                                    });
                                                }
                                                field.onChange(kickOffDate);
                                            } else field.onChange("");
                                            handleValueChanges();
                                            methods.trigger();
                                        }}
                                        placeholder="Select dates"
                                        minDate={new Date().setHours(0, 0, 0, 0)}
                                        size="large"
                                        name="brand_info_general_info_target_launch_date_web_app"
                                        label="Target Launch Date (Web App)"
                                        defaultDate={
                                            methods.watch("brand_info_general_info_target_launch_date_web_app")
                                                ? new Date(methods.watch("brand_info_general_info_target_launch_date_web_app"))
                                                : ""
                                        }
                                    />
                                )}
                            />
                            <ErrorMessage
                                show={
                                    errors.brand_info_general_info_target_launch_date_web_app &&
                                        methods.formState.touchedFields.brand_info_general_info_target_launch_date_web_app
                                        ? true
                                        : false
                                }
                                message={errors.brand_info_general_info_target_launch_date_web_app?.message ?? "Invalid input"}
                            />
                        </div>
                    </div>
                </div>
                <div className="section-space">
                    <div className="sub-heading mb-24">
                        <span className="productIconFlex">
                            <span>
                                Default Font
                            </span>
                            <AppSelectionIcons
                                appSelectionForProgram={appSelectionForProgram}
                                mobileLink="https://example.com/mobile-app-a"
                                webLink="https://example.com/web-app-a"
                            />
                        </span>
                    </div>
                    <I2cAlert
                        open={true}
                        className="alert"
                        variant="primary"
                        type="plain"
                        layout="layoutAsideLeft"
                        headerArt="cs-linear-alert-circle"
                    >
                        <span slot="label">Please note that currently i2c supports only the Hebo font for Web and the SF Pro font for the mobile app.</span>
                    </I2cAlert>
                </div>
            </div>
        </React.Fragment >
    );
};
export default GeneralInformation;
